// eslint-disable

import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'src/components/datagrid'
import { IOrderItem } from 'src/types/orders'

import axiosInstance from 'src/utils/axios'

type Orders = {
  data: IOrderItem[]
  extraData: any
  page: number
  perPage: number
  totalPages: number
  total: number
}

// Store para controlar o cancelamento de requisições
let abortController: AbortController | null = null

async function fetchUser(pagination: Pagination, filters: any): Promise<Orders> {
  // Cancela a requisição anterior se existir
  if (abortController) {
    abortController.abort()
  }

  // Cria um novo AbortController para esta requisição
  abortController = new AbortController()

  let sortName: any = 'createdAt'
  let order: string = 'desc'

  if (pagination.sort) {
    const keyNames = Object.keys(pagination.sort)
    sortName = keyNames[0]
    order = pagination.sort[sortName]
  }

  try {
    const res = await axiosInstance.get('/order', {
      params: {
        ...pagination,
        ...filters,
        sort: sortName,
        order: order === 'desc' ? -1 : 1,
        event: filters?.event?.value,
        salers: filters?.salers?.map((item: any) => item.value),
        categories: filters?.categories?.value,
        paymentType: filters?.paymentType?.map((item: any) => JSON.parse(item).value),
        terminalSerial: filters?.terminalSerial || undefined, // Adiciona terminalSerial
      },
      signal: abortController.signal,
    })
    return res.data
  } catch (error: any) {
    // Se a requisição foi cancelada, não propaga o erro
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      console.log('Requisição cancelada (nova busca iniciada)')
      throw error // React Query vai lidar com isso apropriadamente
    }
    throw error
  }
}

function useOrders(pagination: Pagination, filters?: any) {
  const hasEvent = !!filters?.event?.value

  return useQuery(['orders', pagination, filters], () => fetchUser(pagination, filters), {
    enabled: hasEvent,
    keepPreviousData: true,
    staleTime: 12000,
    retry: (failureCount, error: any) => {
      if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
        return false
      }
      return failureCount < 3
    },
  })
}

export default useOrders
